import { createAction } from 'redux-actions'

const RESET_REPORTS = 'RESET_REPORTS'
const SET_CURRENT_REPORT = 'SET_CURRENT_REPORT'
const SET_REPORTS = 'SET_REPORTS'
const SET_NO_REPORTS = 'SET_NO_REPORTS'
const SET_NO_REPORTS_TEXT = 'SET_NO_REPORTS_TEXT'

const actions = {
    resetReports: createAction(RESET_REPORTS),
    setCurrentReport: createAction(SET_CURRENT_REPORT),
    setReports: createAction(SET_REPORTS),
    setNoReports: createAction(SET_NO_REPORTS),
    setNoReportsText: createAction(SET_NO_REPORTS_TEXT)
}

const types = {
    RESET_REPORTS,
    SET_CURRENT_REPORT,
    SET_REPORTS,
    SET_NO_REPORTS,
    SET_NO_REPORTS_TEXT
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/reports.js